import React from 'react';
import Box from '@mui/material/Box';

interface CoverSliderProps {
  imageSrc?: string;
  imageAlt?: string;
  height?: any;
  maxHeight?: any;
  maxWidth?: any;
}

const CoverSlider = ({
  imageSrc = '/images/others/eor-image1.png',
  imageAlt = '产品展示图片',
  height = { xs: 'auto' },
  maxHeight = { xs: 300, md: 1 },
  maxWidth = { xs: 1, md: 623 },
}: CoverSliderProps): JSX.Element => {
  return (
    <Box
      component={'img'}
      src={imageSrc}
      alt={imageAlt}
      height={height}
      maxHeight={maxHeight}
      maxWidth={maxWidth}
    />
  );
};

export default CoverSlider;
